import {Component, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {ColorComponent} from "../color/color.component";
import {AbstractStyleComponent} from '../abstract-style/abstract-style.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

@Component({
  selector: 'app-shadow',
  imports: [
    ColorComponent,
    ReactiveFormsModule,
    FormsModule
  ],
  templateUrl: './shadow.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './shadow.component.scss'
})
export class ShadowComponent extends AbstractStyleComponent {
  @ViewChild('color') colorComponent!: ColorComponent;

  offsetX: number | null = 0;
  offsetY: number | null = 0;
  blurRadius: number | null = 0;
  spreadRadius: number | null = 0;

  getValue(): any {
    return {
      offsetX: this.offsetX,
      offsetY: this.offsetY,
      blurRadius: this.blurRadius,
      spreadRadius: this.spreadRadius,
      color: this.colorComponent.getValue(),
    }
  }

  setValue(value: any): void {
    this.offsetX = value['offsetX'];
    this.offsetY = value['offsetY'];
    this.blurRadius = value['blurRadius'];
    this.spreadRadius = value['spreadRadius'];
    this.colorComponent.setValue(value['color']);
  }

  isDisabled(): boolean {
    if (this.colorComponent) {
      return this.colorComponent.getValue() === null;
    }

    return true;
  }
}
